import { CSSProperties } from 'react';
import { FadeLoader } from 'react-spinners';

const override: CSSProperties = {
  display: 'block',
  margin: '0 auto',
  borderColor: 'red'
};

function Loader({
  loading = true,
  mainMessage = '',
  subMessage = ''
}: {
  loading?: boolean;
  mainMessage?: string;
  subMessage?: string;
}) {
  return (
    <div
      style={{ height: 'calc(-5rem + 100vh)' }}
      className='sweet-loading flex w-full flex-col items-center justify-center p-8'
    >
      <h2 className='mb-2 text-xl font-semibold text-gray-800'>
        {mainMessage}
      </h2>
      <p className='mb-6 max-w-lg text-gray-600'>{subMessage}</p>
      <FadeLoader
        color={'#36d7b7'}
        loading={loading}
        aria-label='Loading Spinner'
        data-testid='loader'
      />
    </div>
  );
}

export default Loader;
